/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {ChangeDetectorRef, Directive, Optional} from '@angular/core';
import {OompaLoompa} from '../../../utils/chocolate/oompa-loompa';
import {RowActionService} from '../providers/row-action-service';
import {DatagridWillyWonka} from './datagrid-willy-wonka';
export class ActionableOompaLoompa extends OompaLoompa {
private rowActions: RowActionService;
/**
 * @param {?} cdr
 * @param {?} willyWonka
 * @param {?} rowActions
 */
constructor(cdr: ChangeDetectorRef,  willyWonka: DatagridWillyWonka, rowActions: RowActionService) {
        if (!willyWonka) {
            throw new Error("clr-dg-row should only be used inside of a clr-datagrid");
        }
        super(cdr, willyWonka);
        this.rowActions = rowActions;
    }
/**
 * @return {?}
 */
get flavor() {
        return this.rowActions.hasActionableRow;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "clr-datagrid, clr-dg-row"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChangeDetectorRef, },
{type: DatagridWillyWonka, decorators: [{ type: Optional }, ]},
{type: RowActionService, },
];
}

function ActionableOompaLoompa_tsickle_Closure_declarations() {
/** @type {?} */
ActionableOompaLoompa.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ActionableOompaLoompa.ctorParameters;
/** @type {?} */
ActionableOompaLoompa.prototype.rowActions;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
